import { jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useEffect, useState } from "react";
import { useSwiper } from "swiper/react";
export const SliderIndicator = ({ total }) => {
    const swiper = useSwiper();
    const [current, setCurrent] = useState(swiper.activeIndex);
    const showIndicator = current < total;
    useEffect(() => {
        if (!swiper)
            return;
        const updateCurrentIndex = () => {
            setCurrent(swiper.activeIndex);
        };
        updateCurrentIndex();
        swiper.on("slideChange", updateCurrentIndex);
        return () => {
            swiper.off("slideChange", updateCurrentIndex);
        };
    }, [swiper]);
    if (!showIndicator)
        return null;
    return (_jsxs(Box, { position: "absolute", top: "spacing.20", left: "50%", transform: "translateX(-50%)", paddingVertical: "spacing.2", paddingHorizontal: "spacing.8", borderRadius: "radius.rounded", backgroundColor: "color.surface.constant.blackTransparent.default", color: "unsafe_component.imageSlider.color.colorIndicator", typography: {
            "breakpoint.base": "typography.body.14.bold",
            "breakpoint.lg": "typography.body.16.bold",
        }, zIndex: "zIndex.1", children: [current + 1, " / ", total] }));
};
